import BreadCrump from "../tools/breadcrump";
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import HeaderOfPage from "../tools/headerOfPage";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";

export default function ListFacilities() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const cookie = getCookies();
    const [list, setList] = useState<any[]>([]);

    const breadcrump = [
        { name: t('Dashboard'), url: '/dashboard' },
        { name: t('Real Estate System'), url: '/dashboard/RealEstate' },
        { name: t('Feature Management'), url: null },
    ];

    const loaddata = async () => {
        try {
            const res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/realestate/facilities`,
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            const data = res.data.message;
            setList(Array.isArray(data) ? data : []);
        } catch (_) {
            setList([]);
        }
    };

    const onDelete = async (id: string) => {
        const result = await Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this feature?"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        });
        if (result.isConfirmed) {
            try {
                await axios({
                    method: 'delete',
                    url: config.url + '/v1/dashboard/realestate/facilities/' + id,
                    headers: { Authorization: 'Bearer ' + cookie['token'] }
                });
                loaddata();
                Swal.fire(t("Deleted"), t("Feature deleted."), "success");
            } catch (_) {
                Swal.fire(t("Error"), t("Could not delete."), "error");
            }
        }
    };

    useEffect(() => {
        loaddata();
    }, []);

    const getName = (item: any) => {
        const lang = (t('lang') as string) || 'en';
        const name = item?.name;
        if (!name || typeof name !== 'object') return item?.code || '-';
        return name[lang] || name.en || name.ku || name.fa || name.ar || name.tr || item?.code || '-';
    };

    return (
        <div className="text-left bg-white p-3 m-4 directions h-[100vh] mb-5 ">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage name={t("Feature Management")} />

            <div className="flex flex-wrap gap-2 items-center mb-4">
                <button
                    type="button"
                    onClick={() => navigate('/dashboard/RealEstate/facilities/new')}
                    className="py-2.5 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
                >
                    {t("Add Feature")}
                </button>
            </div>

            <div className="overflow-x-auto border border-gray-200 rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Name")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Code")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Active")}</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">{t("Actions")}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {list.length === 0 ? (
                            <tr>
                                <td colSpan={4} className="px-4 py-8 text-center text-gray-500">
                                    {t("No features yet.")}
                                </td>
                            </tr>
                        ) : (
                            list.map((item: any) => (
                                <tr key={item._id}>
                                    <td className="px-4 py-3 text-sm text-gray-900">{getName(item)}</td>
                                    <td className="px-4 py-3 text-sm text-gray-600">{item.code || '-'}</td>
                                    <td className="px-4 py-3 text-sm">
                                        {item.active !== false ? t("Yes") : t("No")}
                                    </td>
                                    <td className="px-4 py-3 text-right">
                                        <button
                                            type="button"
                                            onClick={() => navigate(`/dashboard/RealEstate/facilities/edit/${item._id}`)}
                                            className="p-1.5 text-blue-600 hover:bg-blue-50 rounded inline-flex items-center justify-center"
                                            title={t("Edit")}
                                        >
                                            <EditIcon style={{ fontSize: 18 }} />
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => onDelete(item._id)}
                                            className="p-1.5 text-red-600 hover:bg-red-50 rounded inline-flex items-center justify-center"
                                            title={t("Delete")}
                                        >
                                            <TrashIcon style={{ fontSize: 18 }} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
